<template>
  <div class="quantity-control">
    <button @click="decrement" :disabled="initialQty < 1">
      <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <rect fill="#000000" transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) " x="10" y="3" width="4" height="18"></rect>
        </g>
      </svg>
    </button>
    <input ref="quantityStepper" type="number" :value="initialQty" disabled>
    <button @click="increment">
      <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <rect fill="#000000" x="3" y="10" width="18" height="4"></rect>
          <rect fill="#000000" x="10" y="3" width="4" height="18"></rect>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Quantity',

  props: {
    initialQty: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    increment() {
      this.changeQuantity(this.initialQty + 1);
    },

    decrement() {
      if (this.initialQty <= 0) { return; }
      this.changeQuantity(this.initialQty - 1);
    },

    changeQuantity(quantity) {
      this.$emit('changeQuantity', quantity);
    },
  },
};
</script>

<style scoped>
  .quantity-control {
    display: flex;
  }

  button {
    flex: none;
    padding: 0;
    border-radius: 50%;
    background-color: white;
    box-shadow: inset 0 0 0 4px black;
    height: 32px;
    width: 32px;
    position: relative;
    -webkit-appearance: none;
    appearance: none;
  }

  input[type="number"] {
    flex: 1;
    font-size: 1.62em;
    border: none;
    text-align: center;
    width: 100%;
    background: white;
    -moz-appearance: textfield;
  }

  button:disabled {
    opacity: .24;
  }

  button svg {
    height: 24px;
    width: 24px;
    position: absolute;
    top: 4px;
    left: 4px;
  }
</style>
